"use client";
import { defaultLocale } from "@/config";
import { StyledArticle } from "../Blogs/BlogArticle";
import { useTranslations } from "next-intl";
import { useState } from "react";

const ProductDescription = ({ product, locale }) => {
	const t = useTranslations();
	const [activeKey, setActiveKey] = useState<string>("1");

	const tabItems = [
		{
			label: (
				<div
					className={`font-abeezee ${
						activeKey == "1" ? "bg-[#253333] text-white" : "bg-white text-black"
					} flex h-[50px] items-center justify-center gap-2 rounded-full px-2 text-[16px] font-normal md:gap-4 md:px-4 md:text-[22px]`}
				>
					<span className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-white md:h-[40px] md:w-[40px]">
						<img
							src="/image/miaoshu.svg"
							className="h-[20px] w-[20px] md:h-[26px] md:w-[26px]"
							alt="description"
						/>
					</span>
					<p className="">{t("product.description")}</p>
				</div>
			),
			key: "1",
			children: (
				<StyledArticle>
					<div
						className="w-full p-4"
						dangerouslySetInnerHTML={{
							__html:
								locale == defaultLocale
									? filterSortDsc(product.descriptionJson).longDsc
									: filterSortDsc(product.translation.descriptionJson).longDsc ||
										filterSortDsc(product.descriptionJson).longDsc,
						}}
					/>
				</StyledArticle>
			),
		},
		{
			label: (
				<div
					className={`font-abeezee ${
						activeKey == "2" ? "bg-[#253333] text-white" : "bg-white text-black"
					} flex h-[50px] items-center justify-center gap-2 rounded-full px-2 text-[16px] font-normal md:gap-4 md:px-4 md:text-[22px]`}
				>
					<span className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-white md:h-[40px] md:w-[40px]">
						<img
							src="/image/shipping.svg"
							className="h-[20px] w-[20px] md:h-[26px] md:w-[26px]"
							alt="description"
						/>
					</span>
					<p className="max-md:hidden">{t("common.shippingInfo")}</p>
					<p className="hidden max-md:block">{t("common.Shipping")}</p>
				</div>
			),
			key: "2",
			children: (
				<StyledArticle>
					<div className="!font-abeezee w-full p-4 leading-[30px]">
						<h2>{t("common.Shipping")}</h2>
						<p>{t("common.s1")}</p>
						<p>{t("common.s2")}</p>
						<p>{t("common.s3")}</p>
					</div>
				</StyledArticle>
			),
		},
	];

	return (
		<div className="pdes flex w-full flex-col items-center">
			<div className="flex w-full justify-center">
				<div className="w-full">
					<div className="pdes-tabs-nav flex w-full justify-center">
						{tabItems.map((item) => (
							<button
								key={item.key}
								onClick={() => setActiveKey(item.key)}
								className="m-0 border-none bg-transparent p-0 outline-none"
								style={{ minWidth: 0 }}
							>
								{item.label}
							</button>
						))}
					</div>
					<div className="ant-tabs-content-holder">
						{tabItems.map((item) =>
							item.key === activeKey ? (
								<div key={item.key} className="ant-tabs-tabpane">
									{item.children}
								</div>
							) : null,
						)}
					</div>
				</div>
			</div>
			<style
				dangerouslySetInnerHTML={{
					__html: `
					.product_desc .ant-tabs-tab-btn {
						color: #000 !important;
					}
					.pdes .ant-tabs-nav {
						margin: 0 auto;
						display: flex;
						justify-content: center;
					}
					.pdes .ant-tabs-nav-wrap {
						justify-content: center;
						overflow-x: auto;
						scrollbar-width: none; /* Firefox */
					}
					.pdes .ant-tabs-nav-wrap::-webkit-scrollbar {
						display: none; /* Chrome, Safari, Edge */
					}
					.pdes .ant-tabs-nav-list {
						flex-wrap: nowrap;
					}
					.pdes .ant-tabs-content-holder {
						width: 100%;
					}
					.pdes .ant-tabs-tabpane {
						width: 100%;
					}
					@media (max-width: 768px) {
						.pdes .ant-tabs-nav {
							width: 100%;
						}
						.pdes .ant-tabs-nav-wrap {
							justify-content: flex-start;
						}
					}
		`,
				}}
			></style>
		</div>
	);
};

export default ProductDescription;

type dscList = {
	blocks: dscObj[];
};
type dscObj = {
	data: { text: string };
	type: string;
};
const filterSortDsc = (dsc: string) => {
	const dscObj = JSON.parse(dsc) as dscList;
	let sortDsc = "";
	let longDsc = "";
	if (dscObj && dscObj.blocks.length > 0) {
		sortDsc = dscObj.blocks[1].data.text;
		longDsc = handlerInnerHtml(dscObj.blocks[0].data.text);
	}
	return { sortDsc, longDsc };
};

const handlerInnerHtml = (html: string): string => {
	if (!html) return html;
	return html
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "‘")
		.replace(/&#8217;/g, "’")
		.replace(/&#8211;/g, "–")
		.replace(/&nbsp;/g, " ");
};
